import { configure } from "mobx";
import { createContextFactory } from "@devowl-wp/utils";
import { OptionStore, PluginUpdateStore } from ".";
configure({
  enforceActions: "always"
});
/**
 * A collection of all available stores which gets available
 * through the custom hook useStores in your function components.
 *
 * @see https://mobx.js.org/best/store.html#combining-multiple-stores
 */

class RootStore {
  get context() {
    return this.contextMemo ? this.contextMemo : this.contextMemo = createContextFactory(this);
  }

  constructor() {
    this.optionStore = void 0;
    this.pluginUpdateStore = void 0;
    this.contextMemo = void 0;
    this.optionStore = new OptionStore(this);
    this.pluginUpdateStore = new PluginUpdateStore(this);
  }

  static get StoreProvider() {
    return RootStore.get.context.StoreProvider;
  }

  static get get() {
    return RootStore.me ? RootStore.me : RootStore.me = new RootStore();
  }

}

RootStore.me = void 0;

const useStores = () => RootStore.get.context.useStores();

export { RootStore, useStores };